import { parsePhoneNumberFromString, CountryCode } from 'libphonenumber-js';

export default function convertToE164(phoneInput: string): string {
  const [countryCode, ...numberParts] = phoneInput.trim().split(/\s+/);

  if (!countryCode || numberParts.length === 0) return phoneInput;
  const rawNumber = numberParts.join(' ');

  const phoneNumber = parsePhoneNumberFromString(rawNumber, countryCode as CountryCode);

  return phoneNumber?.isValid() ? phoneNumber.number : phoneInput;
}
